import { usePollContext } from '../../../Context';
import { getIsPollPublished } from '../../helpers';
import PublishedPollTitleSkeleton from './PublishedPollTitle/skeleton';
import UnpublishedPollTitleSkeleton from './UnpublishedPollTitle/skeleton';

export interface PollTitleSkeletonProps {
  className?: string;
}
const PollTitleSkeleton = ({ className }: PollTitleSkeletonProps) => {
  const { poll } = usePollContext();

  const isPollPublished = getIsPollPublished(poll);

  if (isPollPublished) {
    return <PublishedPollTitleSkeleton className={className} />;
  }

  return <UnpublishedPollTitleSkeleton className={className} />;
};

export default PollTitleSkeleton;
